module.exports = __webpack_public_path__ + "static/media/Door-frames.cd02dabd.jpg";